import FilePresentIcon from '@mui/icons-material/FilePresent';
import { Box, Stack } from '@mui/material';
import { getRecieverFactoringRequestOverview } from 'lib/api/factoring';
import type { DocumentOverviewSimplified } from 'lib/api/factoring/types';
import { formatMoney, getShortString } from 'lib/functions/utils';
import {
  BackBubbleButton,
  ContentCard,
  DocumentItem,
  ErrorState,
  HeroHeader,
  type StatusLightType,
  TabContentSkeleton,
} from 'lib/mobileDesignSystem';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

const Documents: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const requestId = id ?? '';
  const {
    data: operation,
    isLoading,
    isError,
  } = getRecieverFactoringRequestOverview(dispatch, { requestId });

  if (isLoading) {
    return <TabContentSkeleton />;
  }

  if (isError) {
    return <ErrorState message="Ocurrió un error al cargar los documentos." />;
  }

  if (!operation) {
    return <ErrorState message="No se encontró la operación." />;
  }

  return (
    <Stack
      sx={{ position: 'relative', flex: 1, minHeight: '100%', px: 0 }}
      spacing={0}
    >
      <Box sx={{ position: 'relative', flexShrink: 0 }}>
        <HeroHeader
          title="Documentos"
          minHeight={60}
          sx={{ width: '100vw', mx: 'calc(-50vw + 50%)' }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            pt: 0.5,
            px: 2,
          }}
        >
          <BackBubbleButton onClick={() => navigate(-1)} />
        </Box>
      </Box>
      <Stack spacing={2} sx={{ px: 2, pt: 2 }}>
        <ContentCard>
          <Stack spacing={0} direction="column">
            {operation.documents.map(
              (document: DocumentOverviewSimplified, index: number) => (
                <DocumentItem
                  key={`document-${document.folio}-${index}`}
                  primaryText={`${getShortString(document.stakeholderName, 20)}`}
                  secondaryText={document.folio + ' · ' + document.type}
                  amount={formatMoney(document.amountDocument)}
                  statusLights={[
                    {
                      type: document.ceddedState as StatusLightType,
                      label: 'Cedida',
                    },
                    {
                      type: document.cancelDateState as StatusLightType,
                      label: 'Reclamos',
                    },
                    {
                      type: document.confirmDateState as StatusLightType,
                      label: 'Acuse',
                    },
                  ]}
                />
              ),
            )}
          </Stack>
        </ContentCard>
      </Stack>
    </Stack>
  );
};

export default Documents;
